{
  "invalidSelection": "Valgte {selectedCount, plural, one {dato} other {datoer}} ikke ledige."
}
